var SortFilters = (function ($) {
    'use strict';
    
    return {
        setActive: function ($object) {
            $('#sort-filters-list').find('.active').removeClass('active');
            $object.parent().addClass('active');
            $('#current-sort-filter').text($object.text());
            $('#current-sort-filter').attr('data-label', $object.text());
        },
        setActiveByValue: function (value) {
            if (value)
            {
                var $object = $('#sort-filters-list').find('.sort-option').filter('[data-filter-value="' + value + '"]').first();
                if ($object)
                {
                    this.setActive($object);
                }
            }
        }
    };
})(jQuery);